import { z } from 'zod';
import { defineEvents } from '@ndrc/app-sdk/events';
import fr from './messages/fr.json' with { type: 'json' };
export const events = defineEvents({
  'analytics.commerce.saved': {
    schema: z.object({
      reportId: z.uuid(),
      environmentId: z.uuid(),
      sourceVersion: z.string().regex(/^[a-f0-9]{64}$/),
    }),
    journal: { label: fr.shop.event, importance: 'normal' },
    realtime: true,
  },
  'analytics.report.saved': {
    schema: z.object({ reportId: z.uuid(), source: z.enum(['observed', 'scenario']) }),
    journal: { label: fr.event, importance: 'normal' },
    realtime: true,
  },
});
